export default function round(num, digitCount = 2) {
  const numRank = Math.pow(10, digitCount);
  return Math.round(num * numRank) / numRank;
}
